import { UserPreferences } from "../../../../config/constant";
const createObj = configModel => {
  const model = {};
  Object.keys(configModel).map(x => (model[x] = null));
  return model;
};

export const models = createObj(UserPreferences);

export const options = {};

export const Fields = [
  {
    label: "User Preferences",
    type: "spacer",
    line: false,
    xl: "12"
  },
  {
    label: "",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Receive notifications for orders",
    name: UserPreferences.ReceiveOrderNotifications,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "12"
  },
  {
    label: "",
    type: "spacer",
    line: true,
    xl: "12"
  }
];
